.currencyList {
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  max-height: 100%;

  .search {
    position: relative;
    padding: 0.75rem;
    border-bottom: 0.0625rem solid var(--neutral-200);
  }

  .list {
    padding: 0.3125rem;
    overflow: auto;

    .currency {
      height: 2.5rem;

      .name {
        padding: 0 0.75rem 0 0;
      }

      img {
        flex: 0 0 auto;
        width: auto;
        height: 1.125rem;
        margin: 0 0.75rem 0 0.625rem;
        border-radius: 0.25rem;
        box-shadow: 0.0625rem 0.0625rem 0 rgba(var(--neutral-500-rgb), 0.3);
        object-fit: cover;

        @media (min-width: 400px) {
          width: auto;
          margin: 0 0.6875rem 0 0.625rem;
        }
      }
    }
  }
}
